import React, { useState } from "react";
import styles from "./StudentDailyAttendanceView.module.css";
import Dropdown from "../../components/Dropdown/Dropdown";
import TabSelector from "../../components/TabSelector/TabSelector";
import SearchBar from "../../components/SearchBar/SearchBar";
import { IoCalendarOutline } from "react-icons/io5";
import { MdQrCodeScanner } from "react-icons/md";
import IconAndLabel from "../../components/IconAndLabel/IconAndLabel";
import { BiLogIn, BiLogOut } from "react-icons/bi"; 
import { IoMdCloseCircleOutline } from "react-icons/io"; 
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { WiThermometer } from "react-icons/wi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import CalendarInput from "../../components/CalendarInput/CalendarInput";



const StudentDailyAttendanceView = () => {
  
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const dispatch = useDispatch();

  const handleCheckIn = () => {
    dispatch(openModal("checkInStudent"));
  };
  const handleCheckOut = () => {
    dispatch(openModal("checkOutStudent"));
  };
  const handleEdit = () => {
    dispatch(openModal("editDetails"));
  };
  const handleAbsent = () => {
    dispatch(openModal("absentDetails"));
  };

  const data = [
    {
      _id: "s1",
      studentName: "John Jacob",
      room: "Room 1",
      checkIn: "10 AM By KD",
      checkOut: "5:00 PM By Darshan",
      absent: "Sick Leave",
    },
    { _id: "s2", studentName: "John Jacob" },
    { _id: "s3", studentName: "John Jacob" },
    { _id: "s4", studentName: "John Jacob" },
    { _id: "s5", studentName: "John Jacob" },
  ];

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName} />,
        room: item.room || "-",
        checkIn: item.checkIn ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.checkIn.split(" By ")[0]}</span>
            <div className={styles.subscriptRow}>
              <span>By {item.checkIn.split(" By ")[1]}</span>
              <div className={styles.divider}></div>
              <WiThermometer
                className={styles.icon}
                onClick={() => console.log("Check In Temp clicked")}
              />
              <IoDocumentTextOutline
                className={styles.icon}
                onClick={() => console.log("Check In Notes clicked")}
              />
            </div>
          </div>
        ) : (
          "-"
        ),

        checkOut: item.checkOut ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>
              {item.checkOut.split(" By ")[0]}
            </span>
            <div className={styles.subscriptRow}>
              <span>By {item.checkOut.split(" By ")[1]}</span>
              <div className={styles.divider}></div>
              <WiThermometer
                className={styles.icon}
                onClick={() => console.log("Check Out Temp clicked")}
              />
              <IoDocumentTextOutline
                className={styles.icon}
                onClick={() => console.log("Check Out Notes clicked")}
              />
            </div>
          </div>
        ) : (
          "-"
        ),

        absent: item.absent ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.absent}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              <WiThermometer
                className={styles.icon}
                onClick={() => console.log("Absent Temp clicked")}
              />
              <IoDocumentTextOutline
                className={styles.icon}
                onClick={() => console.log("Absent Notes clicked")}
              />
            </div>
          </div>
        ) : (
          "-"
        ),
        action: (
          <div style={{ display: "flex", gap: "1rem" }}>
            <BiLogIn
              size={24}
              style={{ color: "green", cursor: "pointer", opacity: 0.50 }} // ✅ now green
              onClick={handleCheckIn}
            />
            <BiLogOut
              size={24}
              style={{ color: "red", cursor: "pointer", opacity: 0.50 }} // ✅ now red
              onClick={handleCheckOut}
            />
            <FiEdit
              size={23}
              style={{ color: "Black", cursor: "pointer", opacity: 0.6 }}
              onClick={handleEdit}
            />
          </div>
        ),
      };
    });
  };
  const columnData = getColumnData(data);

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Room", accessor: "room" },
    { title: "Check in", accessor: "checkIn" },
    { title: "Check out", accessor: "checkOut" },
    { title: "Marked Absent", accessor: "absent" },
    { title: "Action", accessor: "action" },
  ];

  

  return (
    <div className={styles.wrapper}>
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Students"
          count={10}
          bgColor="rgba(from var(--Success_Color) r g b / 0.3)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Pending"
          count={2}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Check In"
          count={1}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
          textColor="Black_Color"
        />
        <ResultAndCount
          label="Check Out"
          count={5}
          bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
          textColor="Black_Color"
        />

        <ResultAndCount
          label="Absent"
          count={3}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.2)"
          textColor="Black_Color"
        />
      </div>
      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Program"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.rightrow}>
            <div className={styles.dateWrapper}>
              <CalendarInput
                label="Select Date"
                required
                value={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                background="var(--Utility_Color1)"
                placeholderColor="var(--Info_Color)"
                iconColor="var(--Grey_Color)"
                borderRadius="12px"
              />
            </div>

            <div
              className={styles.qrIcon}
              onClick={() => console.log("Open QR popup")}
            >
              <MdQrCodeScanner size={25} />
            </div>

            <IconAndLabel
              icon={<BiLogIn size={25} />}
              label="Check in"
              onClick={handleCheckIn}
            />
            <IconAndLabel
              icon={<BiLogOut size={25} />}
              label="Check out"
              onClick={handleCheckOut}
            />
            <IconAndLabel
              icon={<IoMdCloseCircleOutline size={25} />}
              label="Absent"
              onClick={handleAbsent}
            />
          </div>
        </div>

        <div className={styles.tableBox}>
          <Dynamic
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentDailyAttendanceView;
